import * as React from 'react';
import { inject } from 'mobx-react';
import { FormattedHTMLMessage } from 'react-intl';
import { RouteProps } from 'react-router-dom';

import DataStore from '../../store/DataStore';
import messages from '../messages';
import classNames from 'classnames';
interface IDataStore {
  dataStore?: DataStore;
}

const Intro: React.SFC<RouteProps & IDataStore> = ({ dataStore }) => {
  return (
    <div className={classNames('c-bubble__content')}>
      <div className="c-bubble__content-text">
        <FormattedHTMLMessage
          {...{
            ...messages.intro,
            values: {
              firstname: dataStore.firstname,
              surname: dataStore.surname
            }
          }}
        />
      </div>
    </div>
  );
};

export default inject('dataStore')(Intro);



// WEBPACK FOOTER //
// ./src/containers/start/components/Intro.tsx